import React from 'react'
import { EditCloseIcon } from '@/utils/svgIcons';
import { useRouter } from 'next/router';

const ModalHeader = (
    {
        productData,
        setNotebookModal,
        step,
        setStep,
        setActiveOption,
    }: {
        productData: any,
        setNotebookModal : any,
        step: any,
        setStep: any,
        setActiveOption: any
    }
) => {
  const {locale} = useRouter();
  const DemoName = locale == 'ar' ? productData?.product?.demo_name?.ar : productData?.product?.demo_name?.en;
  return (
    <div className="flex justify-between items-center px-4 py-3 border-b shadow-sm">
                    <div className="w-6" /> {/* Spacer to center title */}
                    {typeof DemoName === 'string' && (
                      <h2 className={`text-base text-black mx-auto`}>
                        {DemoName.split('{basmti}')[0]}
                        <span className="text-success-500">
                          {locale === 'ar' ? productData?.product?.replace_name?.ar : productData?.product?.replace_name?.en}
                          {/* {productData.product.replace_name} */}
                        </span>
                        {DemoName.split('{basmti}')[1]}
                      </h2>
                    )}
            
                    {/* {(step === 'info' || step === 'edit') && ( */}
                      <button 
                        className="bg-[#93A3B03D] text-xl p-2 rounded-md" 
                        onClick={()=>{
                          if(step === 'info') {
                            setNotebookModal(false);
                          }
                          if(step === 'edit'){
                            setStep('review');
                            setActiveOption('');
                          }
                          if(step === 'review')
                            setNotebookModal(false);
                        }}
                      >
                        <EditCloseIcon/>
                      </button>
                    {/* )} */}
            </div>
  )
}

export default ModalHeader;